import Vue from 'vue'
import axios from 'axios'
import { Toast } from 'vant'

Vue.use(Toast)
// 添加拦截器
axios.interceptors.request.use((config, promise) => {
  // 给所有请求添加自定义header
  config.headers['Content-Type'] = 'application/json'
  config.headers['accept'] = 'application/problem+json'
   if (localStorage.getItem('token1')) {
      const token =localStorage.getItem('token1');
      config.headers.Authorization = token;
    } 
    //config.headers.Authorization = "A7708AB95B808A5C6110A03DF509B8E2";
  return config
}, error => { // 请求错误处理
  Promise.reject(error)
})

axios.defaults.shouldRetry = (error) => false;//重试条件，默认只要是错误都需要重试

// 响应拦截
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (err) => {
     //  发生网络错误后会走到这里
  })






// WEBPACK FOOTER //
// ./src/api/httpService.js